import { createStyles } from '@mantine/core';

import {
  INTERCOM_LAUNCHER_INSET_PX,
  INTERCOM_LAUNCHER_SIZE_PX,
} from '~/components/Intercom/constants';

const useStyles = createStyles((theme) => ({
  clearOfIntercomLauncher: {
    '&&': {
      bottom: INTERCOM_LAUNCHER_INSET_PX + INTERCOM_LAUNCHER_SIZE_PX + theme.other.spacing._16,
    },
  },
}));

export default useStyles;
